<div
  [class.event-filter-tabs]="context === 'main'"
  [class.event-filter-tabs-modal]="context === 'modal'"
  [style.--tab-count]="options.length"
  [style.--selected-index]="getSelectedIndex()"
  role="tablist"
>
  <div class="tab-indicator" aria-hidden="true"></div>

  @for (opt of options; track opt.value) {
  <button
    type="button"
    class="tab"
    role="tab"
    [attr.aria-selected]="selected === opt.value"
    [class.active]="selected === opt.value"
    (click)="select(opt.value)"
  >
    {{ opt.label | translate }}
  </button>
  }
</div>
